import { BaseService } from '@/modules/Core/services/BaseService' // Asegúrate de tener la interfaz definida
import type { ICitaNovedad, ITipoGeneralesNovedad } from '../interfaces/tablas/ICitaNovedad'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { AxiosResponse } from 'axios'

export class NovedadService extends BaseService<ICitaNovedad> {
    constructor() {
        super({
            baseUrl: 'scheduling/novelty/'
        })
    }
    async getGenerales(
        params?: Record<string, unknown>
    ): Promise<AxiosResponse<IResponseApi<ITipoGeneralesNovedad>>> {
        return this.http.get<IResponseApi<ITipoGeneralesNovedad>>(`/general`, {
            params
        })
    }
}
